"use strict";

exports.__esModule = true;
exports.EditDeviceTagsSection = EditDeviceTagsSection;
var _react = _interopRequireDefault(require("react"));
var _FormGroupField = require("../../Form/FormGroupField");
var _DetailsComponent = require("../../Core/DetailsComponent");
var _Translator = require("../../Core/Translator");
var _DeviceTagSelector = require("../../Device/DeviceTagSelector");
var _DeviceTagListContext = require("../../Device/DeviceTagListContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function EditDeviceTagsSection(_ref) {
  var style = _ref.style;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var deviceTagList = _react["default"].useContext(_DeviceTagListContext.DeviceTagListContext);
  return /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
    heading: translate("TicketDetailsEditForm.deviceGroupsLabel", "Device Groups"),
    content: /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "tags",
      style: style
    }, function (_ref2) {
      var input = _ref2.input;
      return /*#__PURE__*/_react["default"].createElement(_DeviceTagSelector.DeviceTagSelector, {
        minimal: true,
        items: deviceTagList,
        selected: input.value || [],
        onSelect: input.onChange,
        multiple: true
      });
    })
  });
}